import React, { Fragment } from "react";
import ScrollToTop from "react-scroll-up";
import { FiArrowUpRight, FiChevronUp } from "react-icons/fi";
import { FaLinkedinIn } from "react-icons/fa";
import Header from "../component/header/HeaderFive";
import FooterTwo from "../component/footer/FooterTwo";
import Helmet from "../component/common/Helmet";
import posts from "../data/linkedin-posts.json";

const formatDate = (date) => new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric"
});

const BrandProtectionInsights = () => (
  <Fragment>
    <Helmet pageTitle="Brand Protection Insights | Alice Denenberg" />

    <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black" />

    <main className="insights-page">
      <section className="insights-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center">
              <p className="insights-eyebrow">Practical trademark guidance</p>
              <h1>Brand Protection Insights</h1>
              <p className="insights-intro">
                Perspectives on trademark strategy, registration, portfolio management,
                and the decisions that help businesses protect their brands.
              </p>
              <a
                className="insights-linkedin-link"
                href="https://www.linkedin.com/in/alicedenenberg/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn aria-hidden="true" />
                Follow Alice on LinkedIn
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="insights-feed" aria-label="LinkedIn posts">
        <div className="container">
          <div className="row">
            {posts.map((post) => (
              <div className="col-lg-4 col-md-6 col-12" key={post.id}>
                <article className="insight-card">
                  <div className="insight-card-meta">
                    <span>LinkedIn</span>
                    <time dateTime={post.publishedDate}>{formatDate(post.publishedDate)}</time>
                  </div>
                  <h2>{post.title}</h2>
                  {post.images && post.images.length > 0 && (
                    <div className={`insight-card-media ${post.images.length > 1 ? "insight-card-media--multiple" : ""}`}>
                      {post.images.map((image) => (
                        <img
                          key={image.src}
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                      ))}
                    </div>
                  )}
                  <div className="insight-card-copy">
                    {post.content.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
                  </div>
                  <div className="insight-topics" aria-label="Topics">
                    {post.topics.map((topic) => <span key={topic}>{topic}</span>)}
                  </div>
                  <a
                    className="insight-card-link"
                    href={post.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on LinkedIn <FiArrowUpRight aria-hidden="true" />
                  </a>
                </article>
              </div>
            ))}
          </div>
          <p className="insights-disclaimer">
            These posts are provided for general informational purposes only and do not
            constitute legal advice.
          </p>
        </div>
      </section>
    </main>

    <div className="backto-top">
      <ScrollToTop showUnder={160}>
        <FiChevronUp />
      </ScrollToTop>
    </div>

    <FooterTwo />
  </Fragment>
);

export default BrandProtectionInsights;
